<template>
    <div class="app flex-row align-items-center">
        <div class="container">
            <b-row class="justify-content-center">
                <b-col md="8">
                    <b-card-group>
                        <b-card no-body class="p-4">
                            <b-card-body>
                                <b-form @submit.prevent="loginSubmit">
                                    <h1>Login</h1>
                                    <p class="text-muted">Beheeromgeving voor de VVD</p>
                                    <b-input-group class="mb-3">
                                        <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                                        <b-form-input type="email" class="form-control" placeholder="E-mail" v-model="form.email" required />
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                        <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                                        <b-form-input type="password" class="form-control" placeholder="Wachtwoord" v-model="form.password" required />
                                    </b-input-group>
                                    <div v-if="loggingIn" class="container-loading">
                                        <img src="/img/loading.gif" alt="Loading Icon" height="50px">
                                    </div>
                                    <p v-if="loginError" class="text-danger">{{ loginError }}</p>
                                    <b-row>
                                        <b-col cols="6">
                                            <b-button variant="primary" class="px-4" type="submit">Inloggen</b-button>
                                        </b-col>
                                        <b-col cols="6" class="text-right">
                                            <a href="/forgot-password" class="px-0">Wachtwoord vergeten</a>
                                        </b-col>
                                    </b-row>
                                </b-form>
                            </b-card-body>
                        </b-card>
                        <b-card class="d-md-down-none d-flex align-items-center" style="background-image: url('/img/logo-vvd.png'); background-repeat: no-repeat; background-size: auto; background-position: center;">
                        </b-card>
                    </b-card-group>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex';

    export default {
        name: 'Login',
        data() {
            return {
                form: {
                    email: null,
                    password: null,
                }
            }
        },
        methods: {
            ...mapActions([
                'doLogin'
            ]),
            loginSubmit() {
                this.doLogin({
                    email: this.form.email,
                    password: this.form.password
                })
            }
        },
        computed: {
            ...mapState([
                'loggingIn',
                'loginError'
            ])
        },
    }
</script>
